var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 21.5591L7.37288 16.9325C7.12357 16.6832 6.78544 16.5431 6.43288 16.5431C6.08031 16.5431 5.74218 16.6832 5.49288 16.9325C5.24357 17.1818 5.10352 17.5199 5.10352 17.8725C5.10352 18.047 5.1379 18.2199 5.20471 18.3812C5.27151 18.5425 5.36943 18.689 5.49288 18.8125L11.0662 24.3858C11.5862 24.9058 12.4262 24.9058 12.9462 24.3858L27.0529 10.2791C27.3022 10.0298 27.4422 9.6917 27.4422 9.33913C27.4422 8.98656 27.3022 8.64843 27.0529 8.39913C26.8036 8.14982 26.4654 8.00977 26.1129 8.00977C25.7603 8.00977 25.4222 8.14982 25.1729 8.39913L11.9995 21.5591Z",
    fill: "#06B155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick1);
export default __webpack_public_path__ + "static/media/Tick1.79b38f6754c8af557758883bc4aec35f.svg";
export { ForwardRef as ReactComponent };